import React, { useState } from 'react';
import { useFetch } from '../../hooks/useFetch';
import { useToast, Spinner, ErrorBanner, Badge, EmptyState } from '../../components/ui';
import AddWorkOrderModal from './AddWorkOrder';
import { fmt, errMsg } from '../../utils/format';
import api from '../../utils/api';

export default function WorkOrders() {
  const [status, setStatus] = useState('');
  const [addModal, setAddModal] = useState(false);
  const { data, loading, error, refetch } = useFetch(`/api/work-orders${status?`?status=${status}`:''}`, [status]);
  const { showToast, Toast } = useToast();

  const action = async (id, endpoint) => {
    try { await api.post(`/api/work-orders/${id}/${endpoint}`); refetch(); showToast('Work order updated successfully'); }
    catch (err) { alert(errMsg(err)); }
  };

  if (loading) return <Spinner />;
  if (error) return <ErrorBanner message={error} onRetry={refetch} />;
  return (
    <div>

      <div className="page-header">
        <h1>Work Orders</h1>
        <div className="page-actions">
          <select value={status} onChange={e => setStatus(e.target.value)}>
            <option value="">All</option><option value="planned">Planned</option><option value="in_progress">In progress</option><option value="complete">Complete</option><option value="cancelled">Cancelled</option>
          </select>
          <button className="btn btn-primary btn-sm" onClick={() => setAddModal(true)}><i className="ti ti-plus" /> New work order</button>
        </div>
      </div>
      {addModal && <AddWorkOrderModal onClose={() => setAddModal(false)} onSaved={(msg) => { refetch(); showToast(msg || 'Saved'); }} />}
      <div className="card">
        <div className="table-wrap">
          <table>
            <thead><tr><th>ID</th><th>Product</th><th>SKU</th><th>Qty</th><th>Status</th><th>Start date</th><th>Actions</th></tr></thead>
            <tbody>
              {(data || []).map(wo => (
                <tr key={wo.id}>
                  <td style={{ fontFamily:'monospace', fontSize:12 }}>WO-{wo.id}</td>
                  <td style={{ fontWeight:500 }}>{wo.product_name}</td>
                  <td style={{ fontSize:12 }}>{wo.sku}</td>
                  <td>{wo.quantity}</td>
                  <td><Badge status={wo.status} /></td>
                  <td style={{ fontSize:12 }}>{fmt.date(wo.start_date)}</td>
                  <td>
                    <div style={{ display:'flex', gap:4 }}>
                      {wo.status === 'planned' && <button className="btn btn-sm btn-primary" onClick={() => action(wo.id,'start')}>Start</button>}
                      {wo.status === 'in_progress' && <button className="btn btn-sm btn-primary" onClick={() => action(wo.id,'complete')}>Complete</button>}
                      {wo.status === 'planned' && <button className="btn btn-sm btn-danger" onClick={() => action(wo.id,'cancel')}>Cancel</button>}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {!(data||[]).length && <EmptyState icon="ti-tool" message="No work orders found" />}
        </div>
      </div>
    </div>
  );
}
